/* eslint-disable camelcase */
import Vue from 'vue'
import gql from 'graphql-tag'
import createGraphQLClient from '@utils/graphql'

let graphqlClient = null

export const state = {
    objects: {},
    currentRoute: {}
}

export const getters = {}

export const mutations = {
  SET_ROUTES(state, objects) {
      let updatedObjects = {}
      for (let key in objects) {
          if (!objects[key].deleted_at) {
              // Remove the '__typename' field that gets added by GraphQL
              delete objects[key].__typename
              // Stage the update so we can just do one Vue.set
              updatedObjects[objects[key].id] = objects[key]
          } else if (state.objects.hasOwnProperty(objects[key].id)) {
              // Immediately delete the object
              Vue.delete(state.objects, objects[key].id)
          }
      }
      state.objects = {
          ...updatedObjects,
      }
  },
  SET_ROUTE(state, objects) {
    state.currentRoute = objects
  },
}

export const actions = {
  init({ commit, rootState }) {
      // Initialise the GraphQL client
      graphqlClient = createGraphQLClient(rootState)
  },

  async getRoutes({ commit }) {
    try {
        return await
            graphqlClient.query({
                query: gql`
              query getRoutes{
                routes {
                  id
                  active
                  name
                  description
                  schedule_string
                  vehicle {
                    id
                    number_plate
                  }
                  serviceType {
                    id
                    name
                  }
                  created_at
                  deleted_at
                  updated_at
                }
              }
            `,
        }).then((response) => {
          commit('SET_ROUTES', response.data.routes);
          return response.data.routes;
        })
    } catch (ex) {
        console.error(ex)
        throw ex
    }
  },
  async getRouteById({ commit }, { id } = {}) {
    try {
        return await graphqlClient.query({
            query: gql`
              query getRouteById($rid: ID!){
                routeById(id: $rid) {
                  id
                  active
                  name
                  description
                  schedule_string
                  vehicle {
                    id
                    number_plate
                  }
                  serviceType {
                    id
                    name
                  }
                  wasteTypes {
                    id
                    name
                  }
                  created_at
                  deleted_at
                  updated_at
                }
              }
            `,
            variables:{ rid: id }
        }).then((response)=>{
          commit('SET_ROUTE', response.data.routeById)
          return response.data.routeById
        })
    } catch (ex) {
        console.error(ex)
        throw ex
    }
  },
  async createRoute({ commit, dispatch }, params) {
      const {name, description, active, scheduleString, vehicleId, serviceTypeId, wasteTypeIds} = params
      try {
        await graphqlClient.mutate({
          mutation: gql`
          mutation CreateRoute(
            $name: String!
            $description: String!
            $active: Boolean!
            $scheduleString: String!
            $vehicle: ID!
            $serviceType: ID!
            $wasteTypes: [ID]
          ) {
            createRoute(
              route: {
                name: $name
                description: $description
                active: $active
                schedule_string: $scheduleString
                vehicle_id: $vehicle
                service_type_id: $serviceType
                waste_type_ids: $wasteTypes
              }
            ) {
              id
            }
          }
          `,
          variables: { name, description, active, scheduleString, vehicle: vehicleId, serviceType: serviceTypeId, wasteTypes: wasteTypeIds}
        })
        dispatch('getRoutes')
      } catch (ex) {
          console.error(ex)
          throw ex
      }
  },
  async updateRoute({ commit, dispatch }, params) {
    const {id, name, description, active, scheduleString, vehicleId, serviceTypeId, wasteTypeIds} = params
      try {
          const response = await graphqlClient.mutate({
              mutation: gql`
              mutation UpdateRoute(
                $rid: Int!
                $name: String
                $description: String
                $active: Boolean
                $scheduleString: String
                $vehicle: ID
                $serviceType: ID
                $wasteTypes: [ID]
              ) {
                updateRoute(
                  id: $rid
                  route: {
                    name: $name
                    description: $description
                    active: $active
                    schedule_string: $scheduleString
                    vehicle_id: $vehicle
                    service_type_id: $serviceType
                    waste_type_ids: $wasteTypes
                  }
                ) {
                  id
                }
              }
              `,
              variables: { rid: id, name, description, active, scheduleString, vehicle: vehicleId, serviceType: serviceTypeId, wasteTypes: wasteTypeIds}
          })

          commit('SET_ROUTE', response.data.updateRoute)
          dispatch('getRoutes')
      } catch (ex) {
          console.error(ex)
          throw ex
      }
  },
  async deleteRoute({ commit }, {id} = {}) {
      try {
          const response = await graphqlClient.mutate({
              mutation: gql`
              mutation deleteRoute($rid:Int!)  {
                deleteRoute(id: $rid) {
                  id
                }
              }
              `,
              variables: { rid: id},
          })
          commit('SET_ROUTE', response.data.deleteRoute)

      } catch (ex) {
          console.error(ex)
          throw ex
      }
  },
}